// 側邊選單（SideMenu）與手機抽屜選單（DrawerMenu）共用的選單項目。舊版兩檔各寫一份、靠註解提醒同步，這裡合成一份。
// 順序照 Figma（8105:66519）；權限鍵是 OR（任一即可看到）。各項權限的來由見舊版 SideMenu.jsx 註解。
// icon 是元件（不是 JSX），由兩個選單各自決定尺寸（SideMenu size-5、DrawerMenu size-5.5）。
import {
  DashboardIcon,
  RouteIcon,
  TaskListIcon,
  GroupIcon,
  BrandIcon,
  CampaignIcon,
  LabelIcon,
  MessageInboxIcon,
  SettingsIcon,
  FeedbackIcon,
  OplogIcon,
} from '@/components/ui/icons'

// badge：要顯示圓點時的資料來源（見 useMenuBadges）
export const MAIN_MENU = [
  // /home 是 canonical；/dashboard 路由並存，列為 alias 讓直接訪問時也亮
  { href: '/home', aliases: ['/dashboard'], label: 'Dashboard', icon: DashboardIcon },
  { href: '/tasks', label: 'Tasks', icon: TaskListIcon, perms: ['view task overview'] },
  { href: '/tags-manage', label: 'Tags', icon: LabelIcon, perms: ['view tags'] },
  { href: '/lines', label: 'Lines', icon: RouteIcon, perms: ['view line list'] },
  {
    href: '/merchants',
    label: 'Groups',
    icon: GroupIcon,
    // 與 /merchants 頁面外層的 4 鍵聯集一致，否則只有其中一鍵的角色進得了頁卻看不到入口
    perms: ['view merchant list', 'view merchant financial grouping', 'view merchant secondary agent', 'approve merchant pricing'],
    badge: 'pricingPending',
  },
  { href: '/products', label: 'Brand and Products', icon: BrandIcon, perms: ['view product list', 'view product providers'] },
  { href: '/message-inbox', label: 'Message Inbox', icon: MessageInboxIcon, perms: ['view my line messages'] },
  { href: '/feedbacks', label: 'Customer Feedback', icon: FeedbackIcon, perms: ['view my feedback', 'view all feedback'] },
  { href: '/account-permissions', label: 'Users & Roles', icon: SettingsIcon, perms: ['view roles', 'view staff list'] },
  { href: '/campaigns', label: 'Campaigns', icon: CampaignIcon, perms: ['view campaign list'] },
]

export const SYSTEM_MENU = [{ href: '/oplogs', label: 'Oplogs', icon: OplogIcon, perms: ['view operation log'] }]

// 圓點樣式（只有「集團」的待審定價一種）
export const BADGE_STYLE = { pricingPending: { className: 'bg-brand-warning-light-5', size: 'size-2.5' } }

// 目前路徑是否命中該項（含 aliases）
export function isMenuActive(pathname, item) {
  return [item.href, ...(item.aliases ?? [])].some((href) => pathname === href || pathname.startsWith(href + '/'))
}
